import React, { useEffect, useRef } from "react";
import Hls from "hls.js";

const VideoPlayer = ({ src }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (!videoRef.current) return;

    if (src.endsWith(".m3u8")) {
      if (Hls.isSupported()) {
        const hls = new Hls();
        hls.loadSource(src);
        hls.attachMedia(videoRef.current);
        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          videoRef.current.play();
        });
        return () => hls.destroy();
      } else if (videoRef.current.canPlayType("application/vnd.apple.mpegurl")) {
        videoRef.current.src = src;
      }
    } else {
      // fallback for MP4
      videoRef.current.src = src;
    }
  }, [src]);


  return (
    <video
      ref={videoRef}
      id="videos"
      className="w-full h-full object-cover"
      controls
      autoPlay
      muted
    />
  );
};

export default VideoPlayer;
